import React, { useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Label } from "reactstrap";
import { Container, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import CustomReactSelect from "../../../components/CustomReactSelect";
import Header from "../../../components/Header";
import { Redirect, useHistory } from "react-router-dom";
import { EmployeeWorkStatus_API } from "./EmployeeWorkStatus_API";
import { UserConsumer } from "../../../UserContext";
import axios from "axios";
import { AlertPopups } from "../../../components/AlertPopups";
import { Routes } from "../../../configurations/config";

const AddEmployeeWorkStatusForm = () => {
	let token = null;
	const history = useHistory();
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);

	const initialValues = {
		employeeId: "",
		workStatus: "",
		startDate: "",
		endDate: "",
	};
	const startDate = null;
	const [supervisorsEmpList, setSupervisorsEmpList] = useState(null);
	const [statusList, setStatusList] = useState(null);
	const [formFields, setFormFields] = useState(initialValues);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };

		//get status List
		axios
			.get(`${EmployeeWorkStatus_API.GetEmployeeStatusList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const statuses = data.statuses;
					setStatusList(
						statuses.sort((a, b) => a.label.localeCompare(b.label))
					);
				}
			});

		//get Supervisor Employee List
		axios
			.get(`${EmployeeWorkStatus_API.GetSupervisorsEmployeesList}`, {
				headers: header,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const supEmpList = data.map((obj) => {
						return { value: obj.employeeId, label: obj.name };
					});
					setSupervisorsEmpList(
						supEmpList.sort((a, b) =>
							a.label.localeCompare(b.label)
						)
					);
				}
			});
	}, []);

	const handleSubmit = () => {
		const formBody = {
			...formFields,
			employeeId: formFields.employeeId.value,
			workStatus: formFields.workStatus.value,
		};
		axios
			.post(
				`${EmployeeWorkStatus_API.PostEmployeeWorkStatus}`,
				formBody,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Added",
					});
					history.push(Routes.AdminEmployeeWorkStatus);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};

	//form validations
	const validate = Yup.object().shape({
		employeeId: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		workStatus: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		startDate: Yup.string().required("Comments is Required").nullable(),
		endDate: Yup.string().required("Comments is Required").nullable(),
	});

	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ? ( //authorization
					<Container fluid className="container-fluid pl-3 pr-3">
						<Header
							title="Add Employee Work Status"
							headerBorder="true"
							navigateBack={() =>
								history.push(Routes.AdminEmployeeWorkStatus)
							}
						/>

						{/* Form*/}
						<Formik
							enableReinitialize={true}
							initialValues={formFields}
							validationSchema={validate}
							validateOnChange={true}
							onSubmit={() => {
								handleSubmit();
							}}
						>
							{({ errors, handleSubmit }) => (
								<Form>
									<Label className="select-criteria-form-title">
										Invalid/Unmark Attendance
									</Label>
									<Row
										className="container-row-one"
										style={{ justifyContent: "normal" }}
									>
										<Col lg={6}>
											<Form.Group className="d-flex align-items-center m-0">
												<Form.Label className="label mb-0 mr-5">
													Employee Name
												</Form.Label>
												<CustomReactSelect
													options={supervisorsEmpList}
													value={
														formFields.employeeId
													}
													onChange={(value) =>
														setFormFields({
															...formFields,
															["employeeId"]:
																value,
														})
													}
													className={`dropDown ml-0  ${
														errors.employeeId
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Form.Group>
										</Col>
										<Col lg={6}>
											<Form.Group className="d-flex align-items-center m-0">
												<Form.Label className="label mb-0 mr-5">
													Select Status
												</Form.Label>
												<CustomReactSelect
													options={statusList}
													value={
														formFields.workStatus
													}
													onChange={(value) =>
														setFormFields({
															...formFields,
															["workStatus"]:
																value,
														})
													}
													className={`dropDown ml-0  ${
														errors.workStatus
															? "h-auto invalid"
															: "h-auto"
													}`}
												/>
											</Form.Group>
										</Col>
									</Row>

									<Row className="container-row-two">
										<Col lg={6}>
											<Form.Group className="d-flex align-items-center m-0">
												<Form.Label className="label mb-0 mr-4">
													Status Start Date
												</Form.Label>
												<Col className="datepicker-wrapper">
													<DatePicker
														showYearDropdown
														showMonthDropdown
														dateFormatCalendar=" " //for title
														dateFormat="dd/MM/yyyy"
														name="lStartDate"
														className={`custom-container ${
															errors.startDate
																? "h-auto invalid"
																: "h-auto"
														}`}
														onChange={(value) =>
															setFormFields({
																...formFields,
																["startDate"]:
																	value,
															})
														}
														selected={
															formFields.startDate
														}
														autoComplete="off"
														ref={startDatepickerRef}
													/>
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="calender-icon"
														color="keppel"
														onClick={() =>
															openStartDatepicker()
														}
													/>
												</Col>
											</Form.Group>
										</Col>
										<Col lg={6}>
											<Form.Group className="d-flex align-items-center m-0">
												<Form.Label className="label mb-0 mr-4">
													Status End Date
												</Form.Label>
												<Col className="datepicker-wrapper">
													<DatePicker
														showYearDropdown
														showMonthDropdown
														dateFormatCalendar=" " //for title
														dateFormat="dd/MM/yyyy"
														className={`custom-container ${
															errors.endDate
																? "h-auto invalid"
																: "h-auto"
														}`}
														selected={
															formFields.endDate
														}
														onChange={(value) =>
															setFormFields({
																...formFields,
																["endDate"]:
																	value,
															})
														}
														name="lEndDate"
														minDate={startDate}
														autoComplete="off"
														ref={endDatepickerRef}
													/>
													<FontAwesomeIcon
														icon={faCalendarAlt}
														className="calender-icon"
														color="keppel"
														onClick={() =>
															openEndDatepicker()
														}
													/>
												</Col>
											</Form.Group>
										</Col>
									</Row>
									{/* Button */}

									<Row className="extractDetail-form-btns">
										<Col className="p-0">
											<input
												type="submit"
												value="Submit"
												className="submit-btn"
												onClick={handleSubmit}
											/>
										</Col>
									</Row>
								</Form>
							)}
						</Formik>
					</Container>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
};

export default AddEmployeeWorkStatusForm;
